// src/config/siteConfig.js

const domain = window.location.hostname;

const config = {
  localhost: "site2", // default for local testing
  "qulabs.ai": "site1",
  "www.qulabs.ai": "site1",
  "thequantum.ai": "site2",
  "www.thequantum.ai": "site2",
};

export const currentSite = config[domain] || "site1";
